import { keysToSnake } from '../../utils/ObjetosUtil'
import { Evento } from '../../pages/calendario/models'
import { baseApi } from './base.api'

export const calendarioApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Recupera eventos visibles en calendario dentro de un rango de fechas.
     * El tipo es opcional para permitir vistas filtradas o generales.
     */
    recuperarEventos: builder.query<
      Evento,
      { rangoInicio: string; rangoFin: string; tipo?: string | null }
    >({
      query: (arg) => {
        return {
          url: `${window._env_.API_CONTEXTO_CALENDARIO}`,
          params: keysToSnake(arg),
        }
      },
    }),
  }),
})

export const { useRecuperarEventosQuery } = calendarioApi
